export enum MfaStatusEnum {
  ENABLED = "Ativado",
  DISABLED = "Desativado",
  UNKNOWN = "Indisponível"
}

export const StatusMfaDescription: Partial<Record<MfaStatusEnum, string>> ={
  [MfaStatusEnum.ENABLED]: 'Autenticação multifator está ativa para esta conta.',
  [MfaStatusEnum.DISABLED]: 'Autenticação multifator não está ativa para conta.',
  [MfaStatusEnum.UNKNOWN]: 'Não foi possível obter o status do MFA no momento. Tente novamente mais tarde.',
}